import Burger from '@/components/burger/burger-class.js';

document.querySelectorAll('.js-header-burger').forEach(elem => new Burger(elem));